// ============================================
// HOOK - Page Tracking for Google Tag Manager
// ============================================

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook para rastrear cambios de página en una SPA
 * Envía eventos de pageview a Google Tag Manager y Google Analytics
 * cuando el usuario navega entre rutas de React Router
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Enviar pageview a Google Analytics via gtag
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'AW-7931958227', {
        page_path: location.pathname + location.search,
      });
    }

    // Enviar evento personalizado al dataLayer de GTM
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'pageview',
        page: {
          path: location.pathname,
          search: location.search,
          hash: location.hash,
          title: document.title,
          url: window.location.href,
        },
      });
    }

    // Log en desarrollo para debugging
    if (import.meta.env.DEV) {
      console.log('📊 Page tracking:', {
        path: location.pathname,
        search: location.search,
        title: document.title,
      });
    }
  }, [location]);
};

// Declaración de tipos TypeScript para window.gtag y window.dataLayer
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}
